import React from "react";
import idea from "../assets/idea.svg";
import { Translate } from "react-redux-i18n";

const TIP_KEYS = [
  "ad_tip1",
  "ad_tip2",
  "ad_tip3",
  "ad_tip4",
  "ad_tip5",
  "ad_tip6",
  "ad_tip7",
  "ad_tip8",
];

class AdTip extends React.Component {
  render() {
    return (
      <div className="adnew-tip">
        <img className="adnew-tip__icon" src={idea} alt="" />
        <h3 className="adnew-tip__title">
          <Translate value="ad_tip" />
        </h3>
        <ol className="adnew-tip__list">
          {TIP_KEYS.map((key, index) => (
            <li key={key} className="adnew-tip__item">
              <span className="adnew-tip__item-num">{index + 1}.</span>
              <span>
                <Translate value={key} />.
              </span>
            </li>
          ))}
        </ol>
      </div>
    );
  }
}

export default AdTip;
